import { render } from "./Success.vue?vue&type=template&id=68a08a52"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__